import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faEdit, faHeart as faHeartO, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { faCartShopping, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { formatImageUrl } from "../../_helpers/format-image-url";
import { UseCartList } from "../../services/cart/cart.context";

export const UpdateCard = ({ item, onDelete, onUpdate }) => {

    const navigateTo = useNavigate();

    


    return (
        <div
            className="item-card-container"
            style={{
                backgroundImage: `url("${formatImageUrl(item.images[0])}")`
            }}
        >
            <span className="action-buttons">
                <button
                    onClick={onUpdate}
                >
                    <FontAwesomeIcon
                        className="action-icon"
                        icon={faEdit}
                    />
                </button>
                <button
                    onClick={onDelete}
                >
                    <FontAwesomeIcon
                        className="action-icon"
                        icon={faTrashAlt}
                    />
                </button>
            </span>
            <button
                className="card-bg"
                onClick={() => navigateTo("/details", { state: { car: item } })}
            >
                <span className="item-data">
                    <span className="data-unit br">{item?.brand}</span>
                    <span className="data-group">
                        <span className="data-unit  nm">{item?.model}</span>
                        <span className="data-unit nm">{item?.year}</span>
                    </span>
                    <span className="data-unit pr">FCFA {(item?.cost).toLocaleString()}</span>
                </span>

            </button>
        </div>
    );
}